import { Component } from "react";
import styles from "./inputPhone.module.css";
import classnames from "classnames";
import { debounce } from "lodash";
import renderHTML from "html-react-parser";
import { _t } from "src/redux/store";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/plain.css';

type Props = {
  classname?: string;
  name: string;
  value: string;
  label: string;
  info?: string;
  regex: string;
  country?: string;
  regexErrorMessage?:string;
  handleOnChange: Function;
};

type State = {
  value: string;
  phone: string;
  input: {
    isValid: boolean;
    warning: string;
  };
};

class InputPhone extends Component<Props, State> {
  userCountry = 'br';
  constructor(props: Props) {
    super(props);
    this.userCountry = navigator.language.toLowerCase();
    if (this.userCountry.indexOf("-") !== -1){
      this.userCountry = this.userCountry.split("-")[1];
    }
    this.state = {
      value: "",
      phone: "",
      input: {
        isValid: true,
        warning: "",
      },
    };
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.value !== this.state.value) {
      this.debouncedHandleOnChange();
    }
  }

  debouncedHandleOnChange = debounce(() => {
    this.validateInput(this.state.phone);
    this.props.handleOnChange(this.props.name, this.state.phone, this.state.input.isValid);
    
  }, 200);

  handleOnChange = (newValue: string, country: any) => {
    const number = (country.dialCode === newValue ? '' : '+' + newValue);
    this.setState({ value: newValue, phone:number });
  };

  validateInput = (text: string) => {

    const regExp = new RegExp(this.props.regex);
    if (text !== '' && !regExp.test(text)){
      this.setState({
        input: {
          isValid: false,
          warning: (this.props.regexErrorMessage ? this.props.regexErrorMessage : _t.translate("Invalid Pattern")),
        },
      });
    }else{
      this.setState({
        input: {
          isValid: true,
          warning: ''
        },
      });
    }

  };

  render() {
    return (
      <div
        className={classnames(
          styles.formControl,
          typeof this.props.classname !== "undefined" && this.props.classname
        )}
      >
        <span className={styles.label}>{this.props.label}</span>
        <label className={styles.inputWrapper}>
          <PhoneInput
            inputClass={styles.textField}
            dropdownClass={styles.dropdownCountries}
            country={this.userCountry}
            value={this.state.value}
            onChange={(value, country:any) => {
                this.handleOnChange(value, country);
              }
            }
          />
        </label>
        {typeof this.props.info !== "undefined" && (
          <div className={styles.info}>{renderHTML(this.props.info)}</div>
        )}
        {!this.state.input.isValid && (
          <small className={styles.warning}>{this.state.input.warning}</small>
        )}
      </div>
    );
  }
}

export default InputPhone;
